import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import AttendantDetails from "../../components/patient-timeline/attendant"

const AttendantDetailsContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AttendantDetails />
      </div>
    </div>
  )
}

export default AttendantDetailsContainer;
